import React, { useState, FormEvent, useContext, useEffect } from 'react';
import { Segment, Form, Button, Grid, Input, Table } from 'semantic-ui-react';
import { ITechnicianCertificate } from '../../../app/models/techniciancertificate';
import TechnicianCertificateStore from '../../../app/stores/techniciancertificateStore';
import {RootStoreContext} from '../../../app/stores/rootStore';
import { observer } from 'mobx-react-lite';
import { RouteComponentProps } from 'react-router';
import FileDropzone from '../../../app/common/Dropzone/FileDropzone';

interface DetailParams {
  email: string;
}

const TechnicianCertificateCreateForm: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history
}) => {
  const techniciancertificateStore = useContext(TechnicianCertificateStore);
  const rootStore = useContext(RootStoreContext);
  const {openModal} = rootStore.modalStore;
  const { deleteFile, fileRegistry, filesByName, uploadFile } = rootStore.fileStore;
  const {
    createTechnicianCertificate,
    editTechnicianCertificate,
    submitting,
    techniciancertificate: initialFormState,
    loadTechnicianCertificate,
    loadTechnicians,
    techniciansByName,
    loadCertificates,
    certificatesByName,
    certificatesSearch,
    clearTechnicianCertificate,
    searchCertificate,
  } = techniciancertificateStore;

  useEffect(() => {
    loadTechnicians();
    loadCertificates();

    return () => {
      fileRegistry.clear();
    };
  }, []);

  const [technician, setTechnician] = useState({
    technicianEmail: match.params.email,
    remark: ''
  });

  const [techName, setTechName] = useState('');
 
  const [certchecked, setCertificateChecked] = useState(new Map());

  const [expirydate, setExpiryDate] = useState(new Map());

  const [term, setTerm] = useState("");

  const technicianOptions = techniciansByName.map(function (tech) {
    var option = { "key": tech.email, "text": tech.name, "value": tech.email }
    return option;
  }
  );

  const handleSubmit = () => {
    let techniciancert: ITechnicianCertificate[] = new Array();
    certificatesByName.map(cert => {
      let techniciancertificate: ITechnicianCertificate =
    {
      id : '0',
      createdAt: '',
      updatedAt: '',
      technicianEmail: technician.technicianEmail,
      certificateId: '',
      expiryDate: '',
      verified: 'N',
      remark: technician.remark
    };
      const selectcertificate = certchecked.get(cert.id);
      if (selectcertificate === true)
      {
        techniciancertificate.certificateId = cert.id;
        techniciancertificate.expiryDate = expirydate.get(cert.id);
        techniciancert.push(techniciancertificate);
      };
      
    })
    if(techniciancert.length !== 0) 
    createTechnicianCertificate(techniciancert).then(() => uploadFile(techName)).then(() => history.goBack());
  };


  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setTechnician({ ...technician, [name]: value });
  };

  const handleSearch=(event: FormEvent<HTMLInputElement>) => {
    const {value} = event.currentTarget;
    setTerm(value);
    searchCertificate(event.currentTarget.value);
  }

  return (
    <Segment clearing>
      <Form onSubmit={handleSubmit}>
        <Form.Select
          label='Name'
          required
          onChange={(e, { name, value, textContent }) => 
          {setTechnician({ ...technician, [name]: value});
          setTechName(e.currentTarget.innerText);
         }}
          options={technicianOptions}
          search
          name='technicianEmail'
          placeholder='Name'
          value={technician.technicianEmail}
        />

        <Input  type="text" icon="search" placeholder="Search certificate" onChange={handleSearch} value={term}/>
        
        <Grid>
        <br></br>
        <Grid.Column width={5} as={Segment}>
         <h5> Enable Skill: </h5>
        {certificatesSearch.map(certificate => (
          (certificate.category === 'Enable Skill') && <Form.Checkbox
            label={certificate.name}
            checked={certchecked.get(certificate.id)}
            onChange={(e, { checked }) => {
              setCertificateChecked(certchecked => certchecked.set(certificate.id, checked)); 
              if (certchecked.get(certificate.id) === undefined || certchecked.get(certificate.id)===true)
              openModal(
                <Form.Group>
                <Input
                  label='Expiry Date'
                  onChange={(e, { value }) => setExpiryDate(expirydate => expirydate.set(certificate.id, value))}
                  name='expiryDate'
                  type='date'
                  placeholder='Expiry Date'
                />
                </Form.Group>
              )
            }}
            name={certificate.id}
          />
        ))}
        </Grid.Column>
        
        {/* <Grid.Column width={2} as={Segment}>
        <h5> Soft Skill: </h5>
        {certificatesByName.map(certificate => (
          (certificate.category === 'Soft Skill') && <Form.Checkbox
            label={certificate.name}
            checked={certchecked.get(certificate.id)}
            onChange={(e, { checked }) => {
              setCertificateChecked(certchecked => certchecked.set(certificate.id, checked)); 
              if (certchecked.get(certificate.id) === undefined || certchecked.get(certificate.id)===true)
              openModal(
                <Form.Group>
                <Input
                  label='Expiry Date'
                  onChange={(e, { value }) => setExpiryDate(expirydate => expirydate.set(certificate.id, value))}
                  name='expiryDate'
                  type='date'
                  placeholder='Expiry Date'
                />
                </Form.Group>
              )
            }}
            name={certificate.id}
          />
        ))}
        </Grid.Column> */}
        <Grid.Column width={2} as={Segment}>
        <h5> Induction:</h5>
        {certificatesSearch.map(certificate => (
          (certificate.category === 'Induction') && <Form.Checkbox
            label={certificate.name}
            checked={certchecked.get(certificate.id)}
            onChange={(e, { checked }) => {
              setCertificateChecked(certchecked => certchecked.set(certificate.id, checked)); 
              if (certchecked.get(certificate.id) === undefined || certchecked.get(certificate.id)===true)
              openModal(
                <Form.Group>
                <Input
                  label='Expiry Date:'
                  onChange={(e, { value }) => setExpiryDate(expirydate => expirydate.set(certificate.id, value))}
                  name='expiryDate'
                  type='date'
                  placeholder='Expiry Date'
                />
                </Form.Group>
              )
            }}
            name={certificate.id}
          />
        ))}
        </Grid.Column>
        <Grid.Column width={2} as={Segment}>
        <h5>  License: </h5>
        {certificatesSearch.map(certificate => (
          (certificate.category === 'License') && <Form.Checkbox
            label={certificate.name}
            checked={certchecked.get(certificate.id)}
            onChange={(e, { checked }) => {
              setCertificateChecked(certchecked => certchecked.set(certificate.id, checked)); 
              if (certchecked.get(certificate.id) === undefined || certchecked.get(certificate.id)===true)
              openModal(
                <Form.Group>
                <Input
                  label='Expiry Date'
                  onChange={(e, { value }) => setExpiryDate(expirydate => expirydate.set(certificate.id, value))}
                  name='expiryDate'
                  type='date'
                  placeholder='Expiry Date'
                />
                </Form.Group>
              )
            }}
            name={certificate.id}
          />
        ))}
        </Grid.Column>
        <Grid.Column width={5} as={Segment}>
        <h5> Certificate: </h5>
        {certificatesSearch.map(certificate => (
          (certificate.category === 'Certificate') && <Form.Checkbox
            label={certificate.name}
            checked={certchecked.get(certificate.id)}
            onChange={(e, { checked }) => {
              setCertificateChecked(certchecked => certchecked.set(certificate.id, checked)); 
              if (certchecked.get(certificate.id) === undefined || certchecked.get(certificate.id)===true)
              openModal(
                <Form.Group>
                <Input
                  label='Expiry Date'
                  onChange={(e, { value }) => setExpiryDate(expirydate => expirydate.set(certificate.id, value))}
                  name='expiryDate'
                  type='date'
                  placeholder='Expiry Date'
                />
                </Form.Group>
              )
            }}
            name={certificate.id}
          />
        ))}
        </Grid.Column>
        <Grid.Column width={2} as={Segment}>
        <h5>  Police Check & Soft Skills: </h5>
        {certificatesSearch.map(certificate => (
          (certificate.category === 'Police Check' || certificate.category === 'Soft Skill') && <Form.Checkbox
            label={certificate.name}
            checked={certchecked.get(certificate.id)}
            onChange={(e, { checked }) => {
              setCertificateChecked(certchecked => certchecked.set(certificate.id, checked)); 
              if (certchecked.get(certificate.id) === undefined || certchecked.get(certificate.id)===true)
              openModal(
                <Form.Group>
                <Input
                  label='Expiry Date'
                  onChange={(e, { value }) => setExpiryDate(expirydate => expirydate.set(certificate.id, value))}
                  name='expiryDate'
                  type='date'
                  placeholder='Expiry Date'
                />
                </Form.Group>
              )
            }}
            name={certificate.id}
          />
        ))}
        </Grid.Column>
        </Grid>
        <Form.Input
          label='Remark'
          onChange={handleInputChange}
          name='remark'
          placeholder='Remark'
          value={technician.remark}
        />
        {/* <Button
          onClick={() => openModal(<FileDropzone />)}
          floated='left'
          color='blue'
          type='button'
          content='Upload Files'
        />
        <Table>
        <Table.Body>
        {filesByName.map(file => (
          <Table.Row key={file.name}> 
          <Table.Cell>{file.name}</Table.Cell>
          <Table.Cell>{file.size} bytes</Table.Cell>
          <Table.Cell>
          <Button
          onClick={() => deleteFile(file.name)}
          size='mini'
          type='button'
          color='red'
          content='Delete'
        />
          </Table.Cell>
          </Table.Row> 
        ))}
        </Table.Body>
        </Table> */}
        <Button
          loading={submitting}
          floated='right'
          positive
          type='submit'
          content='Submit'
        />
        <Button
          onClick={() => history.goBack()}
          floated='right'
          type='button'
          content='Cancel'
        />
        
      </Form>
    </Segment>
  );
};

export default observer(TechnicianCertificateCreateForm);
